import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';


import {globalStoreMethods} from '../../global-store';
import {ResponseError} from "../../response-error";

Vue.use(Vuex);


export const loginStoreMethods = {
    name: 'loginStore',

    state: {
        titolo: 'titolo'
    },

    getters: {},

    mutations: {},

    actions: {
        makeLogin: 'makeLogin',
        makeLogout: 'makeLogout',
        makeLoginAs: 'makeLoginAs',
        getRouteName: 'getRouteName',
        checkLogin: 'checkLogin',
        sendLoginCredentials: 'sendLoginCredentials'
    }

};

// restituzione store composto
export default {
    namespaced: true,

    state: {
        titolo: 'modulo accesso utente'
    },

    getters: {},

    mutations: {},

    actions: {

        // esecuzione login utente
        async makeLogin({dispatch}, commandArgs) {
            const response = await axios.post('/api/authentication/make-login', commandArgs);
            if (!response.meta.success || response.results.length === 0) throw new ResponseError(response.meta.messages);
            const user = response.results[0];
            dispatch(globalStoreMethods.actions.setUserAndCulture, user, {root: true});
            return user;
        },

        async makeLogout({commit}) {
            commit(globalStoreMethods.mutations.setLoggedUser, null, {root: true});
        },

        async makeLoginAs({commit}, commandArgs) {
            const response = await axios.post('/api/authentication/make-login-as', commandArgs);
            if (!response.meta.success) throw new ResponseError(response.meta.messages);
            const user = response.results[0];
            commit(globalStoreMethods.mutations.setLoggedUser, user, {root: true});
            return user;
        },

        async checkLogin() {
            const response = await axios.post('/api/authentication/check-login');
            return response.meta.success;
        },

        async sendLoginCredentials(any, commandArgs) {
            const response = await axios.post('/api/authentication/send-login-credentials', commandArgs);
         //   if (!response.meta.success) throw new ResponseError(response.meta.messages);
            return response.meta.messages;
        },


        getRouteName(state, user) {
            let routeName = 'product-status-dashboard';
            switch (user.operatorType) {
                case state.rootState.userType.standard:
                    routeName = 'search';
                    break;
                case state.rootState.userType.supervisor:
                    routeName = 'class-authorizations';
                    break;
                case state.rootState.userType.administrator:
                    routeName = 'family-list';
                    break;
                case state.rootState.userType.translator:
                    routeName = 'translation-list';
                    break;
            }
            return routeName;
        }

    }

};